import {
	Typography,
	Stack,
	Button,
	IconButton,
	Tooltip,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RefreshIcon from '@mui/icons-material/Refresh';
import FilterListIcon from '@mui/icons-material/FilterList';

interface PageHeaderProps {
	title: string;
	onRefresh: () => void;
	onToggleFilters?: () => void;
	onAdd?: () => void;
	isAdmin?: boolean;
	loading?: boolean;
}

export default function PageHeader({
	title,
	onRefresh,
	onToggleFilters,
	onAdd,
	isAdmin = false,
	loading = false,
}: PageHeaderProps) {
	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			sx={{ mb: 3, flexShrink: 0 }}
		>
			<Typography component="h1" variant="h4" fontWeight="bold">
				{title}
			</Typography>
			<Stack direction="row" alignItems="center" spacing={1}>
				<Tooltip title="Làm mới">
					<span>
						<IconButton
							onClick={onRefresh}
							disabled={loading}
							sx={{ color: 'primary.main' }}
						>
							<RefreshIcon />
						</IconButton>
					</span>
				</Tooltip>
				{onToggleFilters && (
					<Tooltip title="Bộ lọc">
						<IconButton
							onClick={onToggleFilters}
							sx={{ color: 'primary.main' }}
						>
							<FilterListIcon />
						</IconButton>
					</Tooltip>
				)}
				{isAdmin && onAdd && (
					<Button
						variant="contained"
						startIcon={<AddIcon />}
						onClick={onAdd}
						disabled={loading}
					>
						Thêm
					</Button>
				)}
			</Stack>
		</Stack>
	);
}